/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Cargos_As_Of_Changes_TitleInputs */

const en_cargos_as_of_changes_title = /** @type {(inputs: Cargos_As_Of_Changes_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inventory movements on ${i?.date}`)
};

const es_cargos_as_of_changes_title = /** @type {(inputs: Cargos_As_Of_Changes_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Movimientos de inventario el ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Inventory movements on {date}" |
*
* @param {Cargos_As_Of_Changes_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_as_of_changes_title = /** @type {((inputs: Cargos_As_Of_Changes_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_As_Of_Changes_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_as_of_changes_title(inputs)
	return es_cargos_as_of_changes_title(inputs)
});